import Fetch from "../../helpers/Fetch";
import GroupDTO from "../dtos/Group";

export async function listGroups(): Promise<GroupDTO[]> {
  const token = localStorage.getItem('id_token');
  const fetchRequest = new Fetch<GroupDTO[]>(`/groups`, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
  })

  await fetchRequest.fetch();

  const status = fetchRequest.getStatus();

  if(status === 'success') {
    return fetchRequest.getPayload();
  }

  throw new Error('Failed to fetch groups');
}

export async function listGroupsOverview(): Promise<GroupDTO[]> {
  const token = localStorage.getItem('id_token');
  const fetchRequest = new Fetch<GroupDTO[]>(`/groups/overview`, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
  })

  await fetchRequest.fetch();

  const status = fetchRequest.getStatus();

  if(status === 'success') {
    return fetchRequest.getPayload();
  }

  throw new Error('Failed to fetch groups overview');
}